//#region src/engine/modules/dictionary/domainLinks.ts
var linksOf = /* @__PURE__ */ new WeakMap();
var NONE = /* @__PURE__ */ new Set();
function domainLinks(state) {
	const columns = state.collections.tableColumnEntities;
	const held = linksOf.get(columns);
	if (held) return held;
	const links = /* @__PURE__ */ new Map();
	for (const [id, { domainId }] of Object.entries(columns)) if (domainId) addLink(links, domainId, id);
	linksOf.set(columns, links);
	return links;
}
function addLink(links, domainId, columnId) {
	const linking = links.get(domainId);
	if (linking) linking.add(columnId);
	else links.set(domainId, /* @__PURE__ */ new Set([columnId]));
}
var domainColumnIds = (state, domainId) => domainLinks(state).get(domainId) ?? NONE;
function relinkDomainColumn(state, columnId, from, to) {
	const links = linksOf.get(state.collections.tableColumnEntities);
	if (!links || from === to) return;
	links.get(from)?.delete(columnId);
	if (to) addLink(links, to, columnId);
}
//#endregion
export { domainColumnIds, relinkDomainColumn };
